import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  FetchWalletTransactionsPayload,
  IWallet,
  IWalletChallenge,
  IWalletTransaction,
  SignMessagePayload,
  ValidateAddressPayload,
  ValidateAddressResponse,
  WalletPayload,
  WalletPinPayload,
  WalletStatePayload,
  WalletTransferPayload,
} from '../types/wallet.types';

export const walletApi = createApi({
  reducerPath: 'walletApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/crypto`),
  endpoints: (builder) => ({
    deployWallet: builder.query<ApiResponse<IWalletChallenge>, WalletPayload>({
      query: (params) => ({
        url: `/wallets/${params.id}/deploy`,
        method: 'GET',
      }),
    }),
    getWallet: builder.query<ApiResponse<IWallet>, WalletPayload>({
      query: (params) => ({
        url: `/wallets/${params.id}`,
        method: 'GET',
      }),
    }),
    walletPin: builder.query<ApiResponse<IWalletChallenge>, WalletPinPayload>({
      query: (payload) => ({
        url: '/user/pin',
        method: 'PUT',
        body: payload,
      }),
    }),
    walletState: builder.query<ApiResponse<IWallet>, WalletStatePayload>({
      query: (payload) => ({
        url: `/wallets/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    signMessage: builder.mutation<ApiResponse<IWalletChallenge>, SignMessagePayload>({
      query: (payload) => ({
        url: `/wallets/${payload.id}/sign-message`,
        method: 'POST',
        body: payload,
      }),
    }),
    createWallet: builder.query<ApiResponse<IWalletChallenge>, void>({
      query: () => ({
        url: '/wallets',
        method: 'POST',
      }),
    }),
    transfer: builder.mutation<ApiResponse<IWalletChallenge>, WalletTransferPayload>({
      query: (payload) => ({
        url: '/transactions',
        method: 'POST',
        body: payload,
      }),
    }),
    validateAddress: builder.mutation<ApiResponse<ValidateAddressResponse>, ValidateAddressPayload>({
      query: (payload) => ({
        url: '/transactions/validate-address',
        method: 'POST',
        body: payload,
      }),
    }),
    fetchWalletTransactions: builder.query<ApiPaginationResponse<IWalletTransaction[]>, FetchWalletTransactionsPayload>(
      {
        query: (params) => ({
          url: '/transactions',
          method: 'GET',
          params,
        }),
      },
    ),
  }),
});

export const {
  useLazyGetWalletQuery,
  useLazyFetchWalletTransactionsQuery,
  useTransferMutation,
  useValidateAddressMutation,
  useLazyCreateWalletQuery,
  useSignMessageMutation,

  useLazyDeployWalletQuery,
  useLazyWalletPinQuery,
  useLazyWalletStateQuery,
} = walletApi;
